import {svgIconWrapper} from '../svg-icon-wrapper';

import TypeformRegular from './typeform-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <TypeformRegular {...props} />;
}

SvgComponent.iconName = 'typeformRegular';

export const TypeformRegularIcon = svgIconWrapper(SvgComponent);
